import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ComputedFrom } from '@certemy/common';
import { constants, PHASE_INSTANCE_STATUS, PHASE_INSTANCE_STATUS_NAMES } from 'constants/constants';
import { TYPES } from './status-label.constants';
import { STEP_TYPE_STATUS_NAMES, STEP_TYPE_STATUSES } from 'constants/status.constants';

@Component({
  selector: 'cm-status-label',
  templateUrl: './status-label.component.html',
  styleUrls: ['./status-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusLabelComponent {
  @Input() statusId: number;
  @Input() statusIconTooltip = '';
  @Input() isDetailsView: boolean;
  @Input() showEditIcon: boolean;
  @Input() toBeAudited: boolean;
  @Input() editIconTooltip: string;
  @Input() type: string;
  @Input() organizationContactData = { email: '', name: '' };

  @ComputedFrom('type')
  get certStatuses() {
    const valueMap = {
      [TYPES.CERTIFICATE]: constants.CERTIFICATE_STATUSES,
      [TYPES.STEP]: constants.STEP_TYPE_STATUSES,
      [TYPES.AUDIT_STEP]: constants.STEP_AUDIT_STATUSES,
      [TYPES.PHASE]: PHASE_INSTANCE_STATUS,
    };
    return valueMap[this.type];
  }

  @ComputedFrom('type')
  get certNames() {
    const valueMap = {
      [TYPES.CERTIFICATE]: constants.CERTIFICATE_STATUSES_NAME,
      [TYPES.STEP]: {
        ...STEP_TYPE_STATUS_NAMES,
        [STEP_TYPE_STATUSES.PASSED_DUE_DATE]: 'Past due date',
      },
      [TYPES.AUDIT_STEP]: constants.STEP_AUDIT_STATUS_NAMES,
      [TYPES.PHASE]: PHASE_INSTANCE_STATUS_NAMES,
    };
    return valueMap[this.type];
  }

  @ComputedFrom('statusId', 'certStatuses', 'statusIconTooltip')
  get showStatusIcon(): boolean {
    return this.statusIconTooltip && [this.certStatuses.CREDENTIAL_PAUSED].includes(this.statusId);
  }

  @ComputedFrom('statusId', 'certStatuses')
  get isInProgress(): boolean {
    return [
      this.certStatuses.ACCEPT,
      this.certStatuses.REJECT,
      this.certStatuses.PARTIALLY_COMPLETED,
      this.certStatuses.INCOMPLETE,
    ].includes(this.statusId);
  }

  @ComputedFrom('statusId', 'certStatuses')
  get isCompleted(): boolean {
    return [
      this.certStatuses.COMPLETE,
      this.certStatuses.COMPLETED,
      this.certStatuses.UNDER_AUDIT,
      this.certStatuses.PENDING_VERIFICATION,
    ].includes(this.statusId);
  }

  @ComputedFrom('statusId', 'certStatuses')
  get isDisabled(): boolean {
    return [this.certStatuses.DISABLED, this.certStatuses.PASSED_DUE_DATE].includes(this.statusId);
  }

  @ComputedFrom('statusId', 'certStatuses')
  get isRejected(): boolean {
    return [this.certStatuses.CORRECTIONS_REQUESTED, this.certStatuses.CREDENTIAL_PAUSED].includes(this.statusId);
  }

  @ComputedFrom('statusId', 'certStatuses')
  get isArchived(): boolean {
    return [this.certStatuses.ARCHIVED].includes(this.statusId);
  }
}
